import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

interface Props {
    isAllowed: boolean;
    redirectPath: string;
}

/**
 * LA CHAINE DE REQUETE SURVIT AU REBOND, et sans ça elle mourait ici.
 *
 * Une autre application qui renvoie quelqu'un vers `account` vise la RACINE, pas
 * `/login` : elle ne connaît pas les routes d'ici, et ne devrait pas. La racine est
 * protégée, donc sans session on rebondit vers la connexion, et ce `Navigate` jetait
 * silencieusement tout ce qui suivait le `?`.
 *
 * Constaté sur `?alerte=APP_UNAUTHORIZED` : le portail et le back-office déconnectaient
 * correctement, la personne atterrissait sur un formulaire de connexion **muet**, et rien
 * ne lui disait pourquoi elle avait été mise dehors. Le paramètre était pourtant bien
 * envoyé, et `Login.tsx` savait le lire : il n'arrivait jamais jusqu'à lui.
 *
 * Le chemin change, pas ce qui l'accompagne.
 */
const ProtectedRoute = ({ isAllowed, redirectPath }: Props) => {
    const location = useLocation();

    return isAllowed ? <Outlet /> : <Navigate to={{ pathname: redirectPath, search: location.search }} replace />;
};

export default ProtectedRoute;
